import React from "react";

import Newsletter from "../../components/newsletter";
import SlideContact from "../../components/slideContact";
import ContactForm from "../../components/contactForm";

const ContactPage = () => {
  return (
    <div>
      <SlideContact />
      <ContactForm />
      <Newsletter />
    </div>
  );
};

export default ContactPage;
